import module from 'cheques/module.js'

const schema = {
  fecha_cheque: 'date',
  Factura: 'number',
  importe: 'number',
}

class ChequesEmpresasCuentaBancariaChequesService {
  constructor ($http) {
    this.$http = $http
  }

  get (busqueda) {
    return this.$http.get('/api/empresa/banco/cuenta/chequeslistado', {
      params: {
        empresa: busqueda.empresa,
        cuentabancaria: busqueda.cuentabancaria,
        fechaInicial: busqueda.fechaInicial && busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal && busqueda.fechaFinal.toYMD(),
        estado: busqueda.estado,
      },
      schema,
    })
  }
}

module.service('ChequesEmpresasCuentaBancariaCheques', ChequesEmpresasCuentaBancariaChequesService)




// WEBPACK FOOTER //
// ./src/cheques/services/ChequesEmpresasCuentaBancariaCheques.js